import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material'
import { message } from 'antd'
import UserSelectSearch from '../../../../../components/SelectSearch/UserSelectSearch'
import { useCallback, useState } from 'react'
import ClearIcon from '@mui/icons-material/Clear'
import SaveIcon from '@mui/icons-material/Save'
import { axiosInstance } from '../../../../../hooks/useAxios'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../constants/errors'

interface Props {
  pageId: string
  isOpen: boolean
  onClose: (visible: boolean) => void
  name: string
}

const AssignUserModal = (props: Props) => {
  const { pageId, isOpen, onClose, name } = props
  const [username, setUsername] = useState<string>('')

  const handleAddAssignUser = useCallback(async () => {
    try {
      await axiosInstance.post(`/facebook/pages/addAssign/`, {
        pageId,
        usernames: [username],
      })
      onClose?.(false)
      message.success('บันทึกข้อมูลสำเร็จ')
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }, [pageId, username])

  return (
    <Dialog
      open={isOpen}
      onClose={() => onClose(false)}
      PaperProps={{
        sx: {
          width: '400px',
          maxWidth: '90%!important',
        },
      }}
    >
      <DialogTitle>กำหนดผู้ดูแลเพจ {name}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1">
              <UserSelectSearch
                label={'เลือกผู้ดูแลแชท'}
                onSelect={(e) => setUsername(e?.value.username)}
                name="user"
              />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              gap={1}
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={() => {
                  handleAddAssignUser()
                }}
              >
                บันทึก
              </Button>
              <Button
                variant="contained"
                color="inherit"
                startIcon={<ClearIcon />}
                onClick={() => onClose(false)}
              >
                ปิดหน้าต่าง
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default AssignUserModal
